import { Badge } from "reactstrap";
import { serverUrl } from '../config4js.js';

export const notify = (
  notifMessage,
  notificationAlertRef,
  color = "success",
  icon = "tim-icons icon-check-2"
) => {
  var options = {};
  options = {
    place: "br",
    message: (
      <div>
        <div>{notifMessage}</div>
      </div>
    ),
    type: color,
    icon: icon,
    autoDismiss: 4,
  };
  if (notificationAlertRef && notificationAlertRef.current) {
    notificationAlertRef.current.notificationAlert(options);
  }
};

export const getColor = (text, isFocused) => {
  if (isFocused) {
    return "default";
  }
  if (text === "physics") {
    return "success";
  } else if (text === "coding") {
    return "warning";
  } else if (text === "robotics") {
    return "danger";
  } else {
    return "info";
  }
};

export const renderChip = (
  {
    value,
    text,
    chip,
    isFocused,
    isDisabled,
    isReadOnly,
    handleClick,
    handleDelete,
    className,
  },
  key
) => {
  return (
    <Badge color={getColor(text.toLowerCase(), isFocused)}>
      {text.toLowerCase()}
    </Badge>
  );
};

export const renderNames = (city, state, country, zip) => {
  var total = "";
  if (city !== "" && city !== undefined) {
    total += city + ", ";
  }
  if (state !== "" && state !== undefined) {
    total += state + ", ";
  }
  if (country !== "" && country !== undefined) {
    total += country + ", ";
  }
  return total.replace(/\s*,\s*$/, "");
};

export const getCookie = cname => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
};

// function: getProjects()
// param: userID (return projects made by this userID)
// return: Object, each item in obj contains a project w/ info
export function getProjects(userID, callback) {
  let xhr = new XMLHttpRequest();
  xhr.open(
    "GET",
    serverUrl + "/fetchprojects?userid=" + userID
  );

  xhr.onload = function () {
    if ("status" in JSON.parse(xhr.responseText)) {
      return;
    }
    if(xhr.status === 200){
      callback(JSON.parse(xhr.responseText))
    } else {
      callback("Error" + xhr.status);
    }
  };
  xhr.send();
}

//getLists: display all lists by param userID
export function getLists(userID, callback){
  let xhr = new XMLHttpRequest();
  xhr.open(
    "GET",
    serverUrl + "/fetchuserplaylists?user_id=" + userID
  );

  xhr.onload = function () {
    if ("status" in JSON.parse(xhr.responseText)) {
      return;
    }
    if(xhr.status === 200){
      callback(JSON.parse(xhr.responseText))
    } else {
      callback("Error" + xhr.status);
    }
  };
  xhr.send();
}

//getUserLists: get lists of user (of person viewing page)
export function getUserLists(token, callback){
  let xhr = new XMLHttpRequest();
  xhr.open(
    "GET",
    serverUrl + "/fetchuserplaylists?authtoken=" + token
  );

  xhr.onload = function () {
    if ("status" in JSON.parse(xhr.responseText)) {
      return;
    }
    if(xhr.status === 200){
      callback(JSON.parse(xhr.responseText))
    } else {
      callback("Error" + xhr.status);
    }
  };
  xhr.send();
}

export function getProfile(userID, callback){
  let xhr = new XMLHttpRequest();
  xhr.open(
    "GET",
    serverUrl + "/fetchprofile?userid=" + userID
  );

  xhr.onload = function () {
    if (JSON.parse(xhr.responseText)[0] === undefined) {
      return;
    }
    if(xhr.status === 200){
      callback(JSON.parse(xhr.responseText)[0]);
    } else {
      callback("Error" + xhr.status);
    }
  };
  xhr.send();
}

export function getStarred(userID, callback){
  let xhr = new XMLHttpRequest();
  xhr.open(
    "POST",
    serverUrl + "/fetchstarred?user_id=" + userID
  );

  xhr.onload = function () {
    if (JSON.parse(xhr.responseText)[0] === undefined) {
      return;
    }
    if(xhr.status === 200){
      callback(JSON.parse(xhr.responseText));
    } else {
      callback("Error" + xhr.status);
    }
  };
  xhr.send();

}

export function addPlaylist(token, fileID, lists, callback) {
  let xhr = new XMLHttpRequest();
  xhr.open("POST", serverUrl + "/getplaylistsforproject?authtoken=" + token);
  xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
  
  xhr.onload = function () {
    var list_ids = JSON.parse(xhr.responseText);
    list_ids = list_ids.map(list_id => list_id.playlist_id);
    const updatedCheckedState = lists.map((item) => {
      if (list_ids.includes(item.playlist_id)) {
        return true;
      } else {
        return false;
      }
    });
     callback(updatedCheckedState);
  }
  xhr.send(
    JSON.stringify({
      project_id: fileID,
    })
  );
}

export const descStyle = {
  display: "block",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  marginBottom: 5
}

export function addDefaultSrc(ev){
  ev.target.src =
  "https://storage.googleapis.com/user-thumbnails/ziro-studio-default" +
  (Math.floor(Math.random() * 5) + 1) +
  ".jpg";
}